import { Autocomplete, Grid, TextField, Typography } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import { useStyle } from "../style";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import axios from "axios";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import moment from "moment";
import dayjs from "dayjs";

const PurchaseInfo = ({setData,setPostData}) => {
  const classes = useStyle();
  const dispatch = useDispatch()
  const [billData, setBillData] = useState([])
  const [docNo, setDocNo] = useState('')
  const[balance, setBalance] = useState('0.00')
  const [billNo, setBillNo] = useState(null)
  const [address , setAddress] = useState("")
  const [gstIn , setGstIn] = useState("")
  const [partyName , setPartyName] = useState("")
  const [date , setDate] = useState(moment().format())
  
  function handleBillChange(e, value) {
    setBillNo(value);
    if (value) {
      const selectedBill = billData.find((bill) => bill.docno === value.docno);
      // Update state based on the selected bill
      console.log(selectedBill)
      setAddress(selectedBill ? (selectedBill.add1 + " " + selectedBill.add2 + "," + selectedBill.city_name + "-" + selectedBill.pincode + "-" + selectedBill.state_name + "-" + selectedBill.country_name) : '');
      setGstIn(selectedBill ? selectedBill.gstin : '');
      setPartyName(selectedBill ? selectedBill.name : '');
      setDate(selectedBill ? selectedBill.docdate : moment().format());
    } else {
      // Clear values if no bill is selected
      setAddress('');
      setGstIn('');
      setPartyName('');
      setDate(moment().format());
    }
  }

  useEffect(()=>{
axios.get('/v1/purchase_return_doc')
.then(res=>setDocNo(res.data.Docno))
.catch(err=> {
  dispatch(setSnackbar(true, 'error', err.response.data.errors[0].message))
})
axios.get('/v1/purchasedocnos')
.then(res=>{
  setBillData(res.data)
  setData([])
})
.catch(err=>{
  console.log(err)
  dispatch(setSnackbar(true,'error',err.response.data.errors[0].message))
})
  },[])

  useEffect(() => {
    if (billNo !== null) {
      axios.get(`/v1/purchase/${billNo.docno}`)
        .then(res => {
          // Check if all items have a quantity of zero
          const allZeroQuantity = res.data.every(item => item.qty === 0);
          if (allZeroQuantity) {
            dispatch(setSnackbar(true, 'warning', 'All items in this bill have already been returned!'));
          } else {
            // If not all items have zero quantity, proceed with setting data
            const arrData = res.data.map(item => ({
              ...item,
              retQty: 0,
              totalAmt: parseFloat(item.qty * (item.rate - item.rate * item.dis_per / 100)).toFixed(2)
            }));
            setData(arrData);
            setBalance(res.data[0].balance);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }, [billNo]);
  useEffect(() => {
    if(billNo){
      setPostData((prevState)=>({...prevState, partycode:billNo.partycode , company_id:billNo.company_id,billno: billNo.docno}))
    }
  },[billNo])
  

  return (
    <Grid container spacing={2} className="p-2 h-full" >
         <Grid item lg={4} >
         <Autocomplete 
        id="billNo"
        name="billNo"
        size="small"
        options={billData}
        getOptionLabel={option=> option.docno}
        onChange={(e,value)=>handleBillChange(e,value)}
        value={billNo}
        renderInput={(params)=>(
          <TextField {...params}
          label='Bill No'/>
        )}
        />
         <TextField size="small" label='Party Name' fullWidth sx={{marginBlock:1.5}} value={partyName}/>
         <TextField size="small" label='Address' disabled multiline rows={3.3} fullWidth value={address}/>
         </Grid>
        <Grid item lg={4}>
        <TextField size="small" label='Doc No' fullWidth 
        value={docNo}
        InputProps={{
          readOnly: true,
        }} />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker value={dayjs(date)} label="Date" size="small"  slotProps={{
                  textField: {
                    size: "small",
                  },
                }}
                
                sx={{width: '100%',marginBlock:1.5}}
                />
        </LocalizationProvider>
        <TextField size="small" label='GSTIN' fullWidth disabled value={gstIn}/>
        </Grid>
   <Grid item lg={4}>
        <Typography textAlign="center" variant="h6" sx={{backgroundColor:'#83A2FF',}}>Balance</Typography>
        <Typography textAlign='right' variant="h5" mt={1} sx={{fontWeight:600,}}>{balance}</Typography>
   </Grid>
    </Grid>
  );
};

export default memo(PurchaseInfo);
